module.exports = {
  'Select your language': 'Select your language',

  'IFT Home Page': 'IFT Home page',
  'lang-en': 'English',
  'lang-zh': '繁體中文',

  'Address': 'Address',
  'E-mail': 'E-mail',
  'Phone': 'Phone',
  'Fax': 'Fax',
  'IFT address': 'Colina de Mong-Há, Macao, China',
  'Download Year Report': 'Download full version IFT 2017/18 Annual Report',
  'Footer copyright text': 'IFT all rights reserved.',

  'more': 'more',
  'year': 'year',

  'Income and Expenditure': 'Income and Expenditure',
  'Human Captional': 'Human Captional',
  'Items': 'Items',
  'Total': 'Total',
  'Actual expenditure': 'Actual expenditure',
  'Actual income': 'Actual income',
  'Actual expenditure for fiscal year 2017': 'Actual expenditure for fiscal year 2017',
  'Actual income for fiscal year 2017': 'Actual income for fiscal year 2017',
  'Full-time faculty statistics': 'Full-Time Academic Staff',
  'Full-time staff statistics': 'Full-Time Staff',
  'Position': 'Position',
  'Number of people': 'Number of people',

  'Global Internship Providers in Academic Year 2017/18': 'Global Internship Providers in Academic Year 2017/18',
  'Provider Name': 'Name',
  'Country and Region': 'Country and Region',
  'Vocational Trainees - Academic Year 2017/18 (by course categories)': 'Vocational Trainees - Academic Year 2017/18 (by course categories)',
  'Vocational Trainees - Academic Year 2017/18 (by course types)': 'Vocational Trainees - Academic Year 2017/18 (by course types)',
  'Course Categories': 'Course Categories',
  'Course Types': 'Course Types',
  'Trainees': 'Trainees',
  'Candidates': 'Candidates',
  'Occupational Assessment Candidates - Academic Year 2017/18': 'Occupational Assessment Candidates - Academic Year 2017/18',

  'League of Elite': 'League of Elite',
  'Global Links': 'Global Links',
  'Research': 'Research',
  'Campus': 'Campus',
  'Tourism College': 'Tourism College',
  'Tourism and Hotel School': 'Tourism and Hotel School',
  'Appendices': 'Appendices',
}
